"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(typeof e + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = JohnnieWalkerPhotoboothCell;
var _react = _interopRequireWildcard(require("react"));
var _qrcode = require("qrcode.react");
var _AzertyKeyboard = _interopRequireDefault(require("./AzertyKeyboard"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function JohnnieWalkerPhotoboothCell(_ref9) {
  var cell = _ref9.cell,
    screenType = _ref9.screenType,
    language = _ref9.language,
    project = _ref9.project,
    logEvent = _ref9.logEvent,
    page = _ref9.page,
    intl = _ref9.intl,
    uriTransformer = _ref9.uriTransformer;
  // Font constants
  var FONTS = {
    headline: 'JohnnieWalkerHeadline, JohnnieWalkerSans, Arial, sans-serif',
    sans: 'JohnnieWalkerSans, Arial, sans-serif',
    caps: 'JWCapsSans, JohnnieWalkerSans, Arial, sans-serif',
    script: 'JohnnieWalkerScript, JohnnieWalkerSans, Arial, sans-serif',
    serif: 'JohnnieWalkerSerif, JohnnieWalkerSans, Arial, sans-serif',
    book: 'JWBook, JohnnieWalkerSans Arial, sans-serif,'
  };
  var _ref0 = (0, _react.useState)(false),
    _ref1 = _slicedToArray(_ref0, 2),
    isInitialized = _ref1[0],
    setIsInitialized = _ref1[1];
  var _ref10 = (0, _react.useState)(null),
    _ref11 = _slicedToArray(_ref10, 2),
    error = _ref11[0],
    setError = _ref11[1];
  var _ref12 = (0, _react.useState)(true),
    _ref13 = _slicedToArray(_ref12, 2),
    loading = _ref13[0],
    setLoading = _ref13[1];
  var videoRef = (0, _react.useRef)(null);
  var _ref14 = (0, _react.useState)(4),
    _ref15 = _slicedToArray(_ref14, 2),
    count = _ref15[0],
    setCount = _ref15[1];
  var _ref16 = (0, _react.useState)([]),
    _ref17 = _slicedToArray(_ref16, 2),
    photos = _ref17[0],
    setPhotos = _ref17[1]; // Array to store the photos taken
  var _ref18 = (0, _react.useState)({
      index: 0,
      photoUri: null
    }),
    _ref19 = _slicedToArray(_ref18, 2),
    currentPhoto = _ref19[0],
    setCurrentPhoto = _ref19[1]; // Current photo being captured
  var _ref20 = (0, _react.useState)(0),
    _ref21 = _slicedToArray(_ref20, 2),
    step = _ref21[0],
    setStep = _ref21[1]; // Step to track the current state of the photobooth
  var _ref22 = (0, _react.useState)(false),
    _ref23 = _slicedToArray(_ref22, 2),
    printed = _ref23[0],
    setPrinted = _ref23[1]; // Track if the photo has been printed
  var _ref24 = (0, _react.useState)(''),
    _ref25 = _slicedToArray(_ref24, 2),
    email = _ref25[0],
    setEmail = _ref25[1]; // Email input for sending the photo
  var _ref26 = (0, _react.useState)(''),
    _ref27 = _slicedToArray(_ref26, 2),
    link = _ref27[0],
    setLink = _ref27[1]; // Link for QR code generation
  var _ref28 = (0, _react.useState)(false),
    _ref29 = _slicedToArray(_ref28, 2),
    isSending = _ref29[0],
    setIsSending = _ref29[1]; // Track if the photo is being sent
  var _ref30 = (0, _react.useState)(false),
    _ref31 = _slicedToArray(_ref30, 2),
    started = _ref31[0],
    setStarted = _ref31[1]; // Track if the photo has been sent
  var _ref32 = (0, _react.useState)(false),
    _ref33 = _slicedToArray(_ref32, 2),
    emailSended = _ref33[0],
    setEmailSended = _ref33[1]; // Track if the email has been sent
  var _ref34 = (0, _react.useState)(null),
    _ref35 = _slicedToArray(_ref34, 2),
    currentDataUri = _ref35[0],
    setCurrentDataUri = _ref35[1]; // Current data URI of the photo being captured
  var _ref36 = (0, _react.useState)(null),
    _ref37 = _slicedToArray(_ref36, 2),
    blops = _ref37[0],
    setBlops = _ref37[1]; // Array to store the Blobs of the photos taken
  var _ref38 = (0, _react.useState)(null),
    _ref39 = _slicedToArray(_ref38, 2),
    forPrint = _ref39[0],
    setForPrint = _ref39[1];
  var _ref40 = (0, _react.useState)(null),
    _ref41 = _slicedToArray(_ref40, 2),
    plainImageForPrint = _ref41[0],
    setPlainImageForPrint = _ref41[1]; // Blob for printing
  var _ref42 = (0, _react.useState)(0),
    _ref43 = _slicedToArray(_ref42, 2),
    resultsStep = _ref43[0],
    setResultsStep = _ref43[1]; // Track which results step (0=options, 1=email, 2=qr, 3=print)
  var _ref44 = (0, _react.useState)(''),
    _ref45 = _slicedToArray(_ref44, 2),
    emailAddress = _ref45[0],
    setEmailAddress = _ref45[1]; // Email input
  var _ref46 = (0, _react.useState)(false),
    _ref47 = _slicedToArray(_ref46, 2),
    termsAccepted = _ref47[0],
    setTermsAccepted = _ref47[1]; // Terms checkbox
  var _ref48 = (0, _react.useState)(false),
    _ref49 = _slicedToArray(_ref48, 2),
    marketingAccepted = _ref49[0],
    setMarketingAccepted = _ref49[1]; // Marketing checkbox
  var _ref50 = (0, _react.useState)(false),
    _ref51 = _slicedToArray(_ref50, 2),
    isProcessingPhoto = _ref51[0],
    setIsProcessingPhoto = _ref51[1]; // Loading state during photo processing
  var _ref52 = (0, _react.useState)(false),
    _ref53 = _slicedToArray(_ref52, 2),
    isPrinting = _ref53[0],
    setIsPrinting = _ref53[1]; // Loading state during printing
  var circleRef = (0, _react.useRef)(null);
  var _ref54 = (0, _react.useState)(0),
    _ref55 = _slicedToArray(_ref54, 2),
    animationKey = _ref55[0],
    setAnimationKey = _ref55[1]; // Key to restart animation
  // New states for instruction screens
  var _ref56 = (0, _react.useState)(0),
    _ref57 = _slicedToArray(_ref56, 2),
    instructionStep = _ref57[0],
    setInstructionStep = _ref57[1]; // 0, 1, 2 for the 3 instruction screens
  var _ref58 = (0, _react.useState)(true),
    _ref59 = _slicedToArray(_ref58, 2),
    showInstructions = _ref59[0],
    setShowInstructions = _ref59[1]; // Show instruction screens first
  var _ref60 = (0, _react.useState)(false),
    _ref61 = _slicedToArray(_ref60, 2),
    keyboardVisible = _ref61[0],
    setKeyboardVisible = _ref61[1];
  // Camera restart states
  var _ref62 = (0, _react.useState)(false),
    _ref63 = _slicedToArray(_ref62, 2),
    isRestarting = _ref63[0],
    setIsRestarting = _ref63[1]; // Track if camera is restarting
  var _ref64 = (0, _react.useState)(false),
    _ref65 = _slicedToArray(_ref64, 2),
    showRestartButton = _ref65[0],
    setShowRestartButton = _ref65[1]; // Show restart button when camera fails

  // Instruction screens data
  var instructionData = [{
    step: "Step 2",
    title: "1. POSITION",
    instruction: "STAND IN THE CENTRE OF THE SCREEN",
    progress: 25,
    timerImage: uriTransformer("https://web-treeosk.online/apks/timer_one.svg")
  }, {
    step: "Step 3",
    title: "2. POSE",
    instruction: "STRIKE A POSE WITH THE COUTURE FLASK",
    progress: 75,
    timerImage: uriTransformer("https://web-treeosk.online/apks/timer_two.svg")
  }, {
    step: "Step 4",
    title: "3. FLASH",
    instruction: "GET READY TO BE PHOTOGRAPHED",
    progress: 100,
    timerImage: uriTransformer("https://web-treeosk.online/apks/timer_three.svg")
  }];

  // Handle instruction screen progression
  (0, _react.useEffect)(function () {
    if (!showInstructions) return;
    var timer = setTimeout(function () {
      if (instructionStep < 2) {
        setInstructionStep(function (prev) {
          return prev + 1;
        });
      } else {
        // After all 3 instruction screens, start the camera
        setShowInstructions(false);
        setStep(0); // Start camera step
      }
    }, 3000); // 3 seconds delay

    return function () {
      return clearTimeout(timer);
    };
  }, [instructionStep, showInstructions]);
  (0, _react.useEffect)(function () {
    function startCamera() {
      return _startCamera.apply(this, arguments);
    }
    function _startCamera() {
      _startCamera = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var stream, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!showInstructions) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return navigator.mediaDevices.getUserMedia({
                video: {
                  width: {
                    ideal: 2160
                  },
                  height: {
                    ideal: 3840
                  },
                  facingMode: 'user'
                },
                audio: false
              });
            case 2:
              stream = _context.v;
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
              }
              setIsInitialized(true);
              setLoading(false);
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t2 = _context.v;
              console.error('Camera initialization failed:', _t2);
              setError(_t2);
              setLoading(false);
              setShowRestartButton(true); // Show restart button when camera fails
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return _startCamera.apply(this, arguments);
    }
    startCamera();
  }, [showInstructions]);

  // Process photo for sharing when 4 photos are ready
  (0, _react.useEffect)(function () {
    if (photos.length === 4 && step === 3) {
      processPhotoForSharing(); // Process photo for sharing (QR, Print, Email)
    }
  }, [step, photos]);

  // Call handleShare when QR code step is shown to ensure link is set
  (0, _react.useEffect)(function () {
    if (resultsStep === 2 && !link && !emailAddress) {
      // Only call handleShare for QR code generation when no email is involved
      handleShare();
    }
  }, [resultsStep, link, emailAddress]);

  // Auto-start countdown when camera is initialized (only after instruction screens)
  (0, _react.useEffect)(function () {
    if (isInitialized && !started && step === 0 && !showInstructions) {
      // Check if video is ready with valid dimensions
      var _checkVideoReady = function checkVideoReady() {
        var video = videoRef.current;
        if (video && video.videoWidth > 0 && video.videoHeight > 0) {
          captureOnePhoto();
        } else {
          setTimeout(_checkVideoReady, 500); // Retry every 500ms
        }
      };

      // Start checking after a short delay
      var timer = setTimeout(_checkVideoReady, 2000);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [isInitialized, started, step, showInstructions]);

  // Process photo for sharing when photo is captured
  (0, _react.useEffect)(function () {
    if (step === 3 && photos.length > 0) {
      processPhotoForSharing();
    }
  }, [step, photos]);
  var createPlainImageForPrint = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var canvasWidth, canvasHeight, canvas, ctx;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (photos[0]) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, null);
          case 1:
            // Use smaller dimensions for print to reduce file size
            canvasWidth = 1080; // Reduced from 2160
            canvasHeight = 1620; // Reduced from 3240
            canvas = document.createElement('canvas');
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
            ctx = canvas.getContext('2d');
            return _context2.a(2, new Promise(function (resolve) {
              // Draw the captured photo directly without background
              var photoImg = new Image();
              photoImg.crossOrigin = 'anonymous';
              photoImg.src = photos[0];
              photoImg.onload = function () {
                // Calculate crop for objectFit: 'cover' to fill entire canvas
                var imgAspect = photoImg.width / photoImg.height;
                var canvasAspect = canvasWidth / canvasHeight;
                var sourceX = 0,
                  sourceY = 0,
                  sourceWidth = photoImg.width,
                  sourceHeight = photoImg.height;
                if (imgAspect > canvasAspect) {
                  // Image is wider than canvas - crop width
                  sourceWidth = photoImg.height * canvasAspect;
                  sourceX = (photoImg.width - sourceWidth) / 2;
                } else {
                  // Image is taller than canvas - crop height
                  sourceHeight = photoImg.width / canvasAspect;
                  sourceY = (photoImg.height - sourceHeight) / 2;
                }

                // Draw the photo to fill entire canvas (no background, no margins)
                ctx.translate(canvasWidth, 0);
                ctx.scale(-1, 1); // Mirror the image
                ctx.drawImage(photoImg, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, canvasWidth, canvasHeight);
                var plainImageDataUri = canvas.toDataURL('image/jpeg', 0.8);
                console.log('🖼️ Created plain image for print - length:', plainImageDataUri.length);
                console.log('🖼️ Plain image preview:', plainImageDataUri.substring(0, 100) + '...');
                resolve(plainImageDataUri);
              };
              photoImg.onerror = function () {
                resolve(null);
              };
            }));
        }
      }, _callee2);
    }));
    return function createPlainImageForPrint() {
      return _ref.apply(this, arguments);
    };
  }();
  var createBrandedFrame = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function () {
      var skipDatabaseSave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return /*#__PURE__*/_regenerator().m(function _callee4() {
        var canvasWidth, canvasHeight, gridWidth, gridHeight, gridX, gridY, spacingX, spacingY, photoWidth, photoHeight, canvas, ctx, background, singlePhotoWidth, singlePhotoHeight, photoX, photoY, drawPhotos, photoImg, logoImg, finalImageDataUri;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              // Creates the branded frame with Johnnie Walker logo for sharing (QR, Email)
              // Dimensions du canvas final
              canvasWidth = 2160;
              canvasHeight = 3240; // Zone centrale pour la grille (centrée)
              gridWidth = canvasWidth * 0.8;
              gridHeight = canvasHeight * 0.7;
              gridX = (canvasWidth - gridWidth) / 2;
              gridY = (canvasHeight - gridHeight) / 2; // Espacement relatif (5% de la largeur/hauteur de la zone grille)
              spacingX = gridWidth * 0.05;
              spacingY = gridHeight * 0.05; // Dimensions de chaque photo
              photoWidth = (gridWidth - spacingX) / 2;
              photoHeight = (gridHeight - spacingY) / 2;
              canvas = document.createElement('canvas');
              canvas.width = canvasWidth;
              canvas.height = canvasHeight;
              ctx = canvas.getContext('2d'); // Load and draw the same background as captured image display
              background = new Image();
              background.crossOrigin = 'anonymous';
              background.src = uriTransformer("https://web-treeosk.online/apks/jw_normal_bg.png");
              _context5.n = 1;
              return new Promise(function (resolve) {
                background.onload = function () {
                  ctx.drawImage(background, 0, 0, canvasWidth, canvasHeight);
                  resolve();
                };
                background.onerror = function () {
                  resolve();
                };
              });
            case 1:
              // Draw single photo in center (same as captured image display)
              singlePhotoWidth = canvasWidth * 0.85;
              singlePhotoHeight = canvasHeight * 0.8;
              photoX = (canvasWidth - singlePhotoWidth) / 2;
              photoY = (canvasHeight - singlePhotoHeight) / 2 - 200; // Slightly higher to make room for logo
              drawPhotos = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                  var promises, borderRadius, _loop, index;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        promises = [];
                        borderRadius = Math.min(photoWidth, photoHeight) * 0.22; // arrondi fort
                        _loop = /*#__PURE__*/_regenerator().m(function _loop(index) {
                          var pos, promise;
                          return _regenerator().w(function (_context3) {
                            while (1) switch (_context3.n) {
                              case 0:
                                pos = positions[index];
                                if (photos[index]) {
                                  promise = new Promise(function (resolve) {
                                    var photoImg = new Image();
                                    photoImg.crossOrigin = 'anonymous';
                                    photoImg.src = photos[index];
                                    photoImg.onload = function () {
                                      // Calculer le crop pour objectFit: 'cover'
                                      var imgAspect = photoImg.width / photoImg.height;
                                      var photoAspect = photoWidth / photoHeight;
                                      var sourceX = 0,
                                        sourceY = 0,
                                        sourceWidth = photoImg.width,
                                        sourceHeight = photoImg.height;
                                      if (imgAspect > photoAspect) {
                                        sourceWidth = photoImg.height * photoAspect;
                                        sourceX = (photoImg.width - sourceWidth) / 2;
                                      } else {
                                        sourceHeight = photoImg.width / photoAspect;
                                        sourceY = (photoImg.height - sourceHeight) / 2;
                                      }
                                      ctx.save();
                                      ctx.beginPath();
                                      if (index === 0) {
                                        ctx.moveTo(pos.x + borderRadius, pos.y);
                                        ctx.lineTo(pos.x + photoWidth, pos.y);
                                        ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight);
                                        ctx.lineTo(pos.x, pos.y + photoHeight);
                                        ctx.lineTo(pos.x, pos.y + borderRadius);
                                        ctx.arcTo(pos.x, pos.y, pos.x + borderRadius, pos.y, borderRadius);
                                      } else if (index === 1) {
                                        ctx.moveTo(pos.x, pos.y);
                                        ctx.lineTo(pos.x + photoWidth - borderRadius, pos.y);
                                        ctx.arcTo(pos.x + photoWidth, pos.y, pos.x + photoWidth, pos.y + borderRadius, borderRadius);
                                        ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight);
                                        ctx.lineTo(pos.x, pos.y + photoHeight);
                                        ctx.lineTo(pos.x, pos.y);
                                      } else if (index === 2) {
                                        ctx.moveTo(pos.x, pos.y);
                                        ctx.lineTo(pos.x + photoWidth, pos.y);
                                        ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight);
                                        ctx.lineTo(pos.x + borderRadius, pos.y + photoHeight);
                                        ctx.arcTo(pos.x, pos.y + photoHeight, pos.x, pos.y + photoHeight - borderRadius, borderRadius);
                                        ctx.lineTo(pos.x, pos.y);
                                      } else if (index === 3) {
                                        ctx.moveTo(pos.x, pos.y);
                                        ctx.lineTo(pos.x + photoWidth, pos.y);
                                        ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight - borderRadius);
                                        ctx.arcTo(pos.x + photoWidth, pos.y + photoHeight, pos.x + photoWidth - borderRadius, pos.y + photoHeight, borderRadius);
                                        ctx.lineTo(pos.x, pos.y + photoHeight);
                                        ctx.lineTo(pos.x, pos.y);
                                      }
                                      ctx.closePath();
                                      ctx.clip();
                                      ctx.translate(pos.x + photoWidth, pos.y);
                                      ctx.scale(-1, 1);
                                      ctx.drawImage(photoImg, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, photoWidth, photoHeight);
                                      ctx.restore();
                                      resolve();
                                    };
                                    photoImg.onerror = function () {
                                      resolve();
                                    };
                                  });
                                  promises.push(promise);
                                } else {
                                  ctx.strokeStyle = 'rgba(0,0,0,0)';
                                  ctx.lineWidth = 2;
                                  ctx.strokeRect(pos.x, pos.y, photoWidth, photoHeight);
                                }
                              case 1:
                                return _context3.a(2);
                            }
                          }, _loop);
                        });
                        index = 0;
                      case 1:
                        if (!(index < Math.min(photos.length, 4))) {
                          _context4.n = 3;
                          break;
                        }
                        return _context4.d(_regeneratorValues(_loop(index)), 2);
                      case 2:
                        index++;
                        _context4.n = 1;
                        break;
                      case 3:
                        _context4.n = 4;
                        return Promise.all(promises);
                      case 4:
                        return _context4.a(2);
                    }
                  }, _callee3);
                }));
                return function drawPhotos() {
                  return _ref3.apply(this, arguments);
                };
              }(); // Draw single photo in center
              if (!photos[0]) {
                _context5.n = 2;
                break;
              }
              photoImg = new Image();
              photoImg.crossOrigin = 'anonymous';
              photoImg.src = photos[0];
              _context5.n = 2;
              return new Promise(function (resolve) {
                photoImg.onload = function () {
                  // Calculer le crop pour objectFit: 'cover'
                  var imgAspect = photoImg.width / photoImg.height;
                  var photoAspect = singlePhotoWidth / singlePhotoHeight;
                  var sourceX = 0,
                    sourceY = 0,
                    sourceWidth = photoImg.width,
                    sourceHeight = photoImg.height;
                  if (imgAspect > photoAspect) {
                    sourceWidth = photoImg.height * photoAspect;
                    sourceX = (photoImg.width - sourceWidth) / 2;
                  } else {
                    sourceHeight = photoImg.width / photoAspect;
                    sourceY = (photoImg.height - sourceHeight) / 2;
                  }

                  // Dessiner la photo avec des coins arrondis
                  // const borderRadius = Math.min(singlePhotoWidth, singlePhotoHeight) * 0.15;
                  ctx.save();
                  ctx.beginPath();
                  ctx.roundRect(photoX, photoY, singlePhotoWidth, singlePhotoHeight);
                  ctx.clip();
                  ctx.translate(photoX + singlePhotoWidth, photoY);
                  ctx.scale(-1, 1);
                  ctx.drawImage(photoImg, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, singlePhotoWidth, singlePhotoHeight);
                  ctx.restore();
                  resolve();
                };
                photoImg.onerror = function () {
                  resolve();
                };
              });
            case 2:
              // Add Johnnie Walker logo below the photo (same as captured image display)
              logoImg = new Image();
              logoImg.crossOrigin = 'anonymous';
              logoImg.src = uriTransformer("https://web-treeosk.online/apks/johnnie_walker_vault_harrods_logo.png");
              _context5.n = 3;
              return new Promise(function (resolve) {
                logoImg.onload = function () {
                  var logoWidth = 880;
                  var logoHeight = 380;
                  var logoX = (canvasWidth - logoWidth) / 2;
                  var logoY = photoY + singlePhotoHeight + 20;
                  ctx.drawImage(logoImg, logoX, logoY, logoWidth, logoHeight);
                  resolve();
                };
                logoImg.onerror = function () {
                  resolve();
                };
              });
            case 3:
              finalImageDataUri = canvas.toDataURL('image/jpeg', 0.8);
              setForPrint(finalImageDataUri);
              canvas.toBlob(function (blob) {
                setBlops(blob);
              }, 'image/jpeg', 0.8);
              handleShare(skipDatabaseSave);
            case 4:
              return _context5.a(2);
          }
        }, _callee4);
      })();
    });
    return function createBrandedFrame() {
      return _ref2.apply(this, arguments);
    };
  }();
  var processPhotoForSharing = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(function () {
      var skipDatabaseSave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return /*#__PURE__*/_regenerator().m(function _callee5() {
        var plainImage, canvasWidth, canvasHeight, canvas, ctx, photoImg;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return createBrandedFrame(skipDatabaseSave);
            case 1:
              _context6.n = 2;
              return createPlainImageForPrint();
            case 2:
              plainImage = _context6.v;
              setPlainImageForPrint(plainImage);

              // Canvas dimensions (landscape)
              canvasWidth = 2160;
              canvasHeight = 3240;
              canvas = document.createElement('canvas');
              canvas.width = canvasWidth;
              canvas.height = canvasHeight;
              ctx = canvas.getContext('2d');
              ctx.clearRect(0, 0, canvasWidth, canvasHeight);
              if (photos[0]) {
                photoImg = new Image();
                photoImg.crossOrigin = 'anonymous';
                photoImg.onload = function () {
                  var sourceWidth = photoImg.width;
                  var sourceHeight = photoImg.height;

                  // Ratios
                  var imgRatio = sourceWidth / sourceHeight;
                  var canvasRatio = canvasWidth / canvasHeight;
                  var drawWidth, drawHeight, drawX, drawY;
                  if (imgRatio > canvasRatio) {
                    // Image wider → height fit, crop width
                    drawHeight = canvasHeight;
                    drawWidth = canvasHeight * imgRatio;
                    drawX = (canvasWidth - drawWidth) / 2;
                    drawY = 0;
                  } else {
                    // Image taller → width fit, crop height
                    drawWidth = canvasWidth;
                    drawHeight = canvasWidth / imgRatio;
                    drawX = 0;
                    drawY = (canvasHeight - drawHeight) / 2;
                  }
                  ctx.save();
                  ctx.beginPath();
                  ctx.roundRect(0, 0, canvasWidth, canvasHeight, 0);
                  ctx.clip();

                  // Flip horizontal
                  ctx.translate(canvasWidth, 0);
                  ctx.scale(-1, 1);
                  ctx.drawImage(photoImg, drawX, drawY, drawWidth, drawHeight);
                  ctx.restore();
                  var finalImageDataUri = canvas.toDataURL('image/jpeg', 0.8);
                  setCurrentDataUri(finalImageDataUri);
                  // Don't overwrite forPrint - keep the branded frame from createBrandedFrame

                  canvas.toBlob(function (blob) {
                    setBlops(blob);
                  }, 'image/jpeg', 0.8);
                  handleShare(skipDatabaseSave);
                  setIsProcessingPhoto(false);
                };
                photoImg.onerror = function () {
                  // Handle error silently
                };
                photoImg.src = photos[0];
              }
            case 3:
              return _context6.a(2);
          }
        }, _callee5);
      })();
    });
    return function processPhotoForSharing() {
      return _ref4.apply(this, arguments);
    };
  }();

  // Progress Circle Animation
  (0, _react.useEffect)(function () {
    var el = circleRef.current;
    var progress = 0;
    var endValue = 98;
    var duration = 9000; // 9 seconds
    var interval = duration / endValue;
    var progressAnimation = setInterval(function () {
      progress++;
      el.style.background = "conic-gradient(rgba(0, 70, 155, 0.8) ".concat(progress * 3.6, "deg, rgba(252, 227, 183, 1) 0deg)");
      if (progress >= endValue) clearInterval(progressAnimation);
    }, interval);

    // Cleanup function
    return function () {
      if (progressAnimation) clearInterval(progressAnimation);
    };
  }, [animationKey]);

  /**
   * Handles sending photo via email to the backend API
   * This function is called when user clicks the email send button
   *
   * ISSUE: This function might not be called if the email button doesn't trigger it properly
   * DEBUG: Added console logs to track if this function is being executed
   */
  var handleShare = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function () {
      var skipDatabaseSave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return /*#__PURE__*/_regenerator().m(function _callee6() {
        var requestBody, response, record, tempLink, _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              console.log('🚀 handleShare called - Email sending initiated');
              console.log('📧 Email address:', emailAddress);
              console.log('🖼️ ForPrint available:', !!forPrint);
              console.log('🌐 Backend URI:', project.backEndUri);
              console.log('🔄 Skip database save:', skipDatabaseSave);
              if (forPrint) {
                _context7.n = 1;
                break;
              }
              console.error('❌ No image to share - forPrint is null/undefined');
              return _context7.a(2);
            case 1:
              if (!(emailAddress && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(emailAddress))) {
                _context7.n = 2;
                break;
              }
              console.error('❌ Invalid email address format:', emailAddress);
              throw new Error('Invalid email address');
            case 2:
              if (skipDatabaseSave) {
                _context7.n = 10;
                break;
              }
              _context7.p = 3;
              console.log('⏳ Setting isSending to true');
              setIsSending(true);
              requestBody = {
                cell_id: cell.id,
                image: forPrint,
                // Use the composite image
                email: emailAddress || null,
                // Use the actual email address from input
                body: "My Johnnie Walker photo",
                subject: "My Johnnie Walker photo",
                additional_data: {
                  marketing_accepted: marketingAccepted,
                  terms_accepted: termsAccepted
                }
              };
              console.log('📤 Sending request to API:', {
                url: "".concat(project.backEndUri, "/send_photo"),
                method: 'POST',
                body: requestBody
              });

              // Send photo to backend API
              _context7.n = 4;
              return fetch("".concat(project.backEndUri, "/send_photo"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
              });
            case 4:
              response = _context7.v;
              console.log('📡 API Response status:', response.status);
              console.log('📡 API Response ok:', response.ok);
              if (response.ok) {
                _context7.n = 5;
                break;
              }
              console.error('❌ API request failed with status:', response.status);
              throw new Error('Upload failed');
            case 5:
              _context7.n = 6;
              return response.json();
            case 6:
              record = _context7.v;
              console.log('✅ API Response data:', record);
              setLink(record.image_uri);

              // Log the event for analytics
              logEvent('click', {
                cellId: cell.id,
                pageId: page.id,
                languageCode: intl.locale,
                action: 'send_photo',
                email: emailAddress || null,
                link: record.image_uri
              });
              console.log('✅ Email sent successfully!');
              setKeyboardVisible(false);
              _context7.n = 8;
              break;
            case 7:
              _context7.p = 7;
              _t3 = _context7.v;
              console.error('❌ Error in handleShare:', _t3);
              console.error('❌ Error message:', _t3.message);
            case 8:
              _context7.p = 8;
              console.log('⏳ Setting isSending to false');
              setIsSending(false);
              return _context7.f(8);
            case 9:
              _context7.n = 11;
              break;
            case 10:
              console.log('⏭️ Skipping database save for print action');
              // Still set the link for QR code display even when skipping database save
              if (forPrint) {
                // Create a temporary link for QR code display without saving to database
                tempLink = "temp_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
                setLink(tempLink);
                console.log('🔗 Set temporary link for QR display:', tempLink);
              }
            case 11:
              return _context7.a(2);
          }
        }, _callee6, null, [[3, 7, 8, 9]]);
      })();
    });
    return function handleShare() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleEmailSend = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var _t4;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            if (emailAddress) {
              _context8.n = 1;
              break;
            }
            console.error('❌ No email address provided');
            return _context8.a(2);
          case 1:
            _context8.p = 1;
            _context8.n = 2;
            return handleShare();
          case 2:
            // Only set email sent state if API was successful
            setEmailSended(true);
            setEmailAddress('');
            _context8.n = 4;
            break;
          case 3:
            _context8.p = 3;
            _t4 = _context8.v;
            console.error('❌ Email sending failed:', _t4);
            // Don't set emailSended to true if there was an error
          case 4:
            return _context8.a(2);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function handleEmailSend() {
      return _ref6.apply(this, arguments);
    };
  }();

  // Restart camera function
  var restartCamera = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var stream, tracks, _stream, _t5;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            console.log('🔄 Restarting camera...');
            setIsRestarting(true);
            setShowRestartButton(false);
            setError(null);
            setLoading(true);

            // Clean up existing stream
            if (videoRef.current && videoRef.current.srcObject) {
              stream = videoRef.current.srcObject;
              tracks = stream.getTracks();
              tracks.forEach(function (track) {
                return track.stop();
              });
              videoRef.current.srcObject = null;
            }

            // Reset states
            setIsInitialized(false);
            setStarted(false);
            setStep(0);
            setPhotos([]);
            setCurrentPhoto({
              index: 0,
              photoUri: null
            });
            _context9.p = 1;
            _context9.n = 2;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 1000);
            });
          case 2:
            _context9.n = 3;
            return navigator.mediaDevices.getUserMedia({
              video: {
                width: {
                  ideal: 2160
                },
                height: {
                  ideal: 3840
                },
                facingMode: 'user'
              },
              audio: false
            });
          case 3:
            _stream = _context9.v;
            if (videoRef.current) {
              videoRef.current.srcObject = _stream;
              videoRef.current.play();
            }
            setIsInitialized(true);
            setLoading(false);
            setIsRestarting(false);
            console.log('✅ Camera restarted successfully');
            _context9.n = 5;
            break;
          case 4:
            _context9.p = 4;
            _t5 = _context9.v;
            console.error('❌ Camera restart failed:', _t5);
            setError(_t5);
            setLoading(false);
            setIsRestarting(false);
            setShowRestartButton(true);
          case 5:
            return _context9.a(2);
        }
      }, _callee8, null, [[1, 4]]);
    }));
    return function restartCamera() {
      return _ref7.apply(this, arguments);
    };
  }();
  function handlePrintCall() {
    return _handlePrintCall.apply(this, arguments);
  } // Function to save photo to database immediately after capture
  function _handlePrintCall() {
    _handlePrintCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      var requestBody, response, record, _t6, _t7;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            console.log('🖨️ Print button clicked!');
            console.log('🖼️ PlainImageForPrint available:', !!plainImageForPrint);
            if (!printed) {
              _context0.n = 1;
              break;
            }
            console.log('⚠️ Already printed, returning');
            return _context0.a(2);
          case 1:
            _context0.p = 1;
            setIsPrinting(true);
            console.log('🔄 Calling processPhotoForSharing to ensure images are ready...');
            _context0.n = 2;
            return processPhotoForSharing(true);
          case 2:
            // Pass true to skip database save

            console.log('🖨️ Sending plain image for printing...');
            console.log('🔍 PlainImageForPrint length:', plainImageForPrint ? plainImageForPrint.length : 'null');
            console.log('🔍 PlainImageForPrint preview:', plainImageForPrint ? plainImageForPrint.substring(0, 100) + '...' : 'null');

            // Print the plain image (without background and logo)
            if (window.electronAPI) {
              window.electronAPI.sendImageForPrint(plainImageForPrint);
            }
            if (window.Android && typeof window.Android.postMessage === 'function') {
              window.Android.postMessage(plainImageForPrint);
            }

            // Save print action to database
            _context0.p = 3;
            console.log('💾 Auto-saving print action to database...');
            requestBody = {
              cell_id: cell.id,
              image: plainImageForPrint,
              email: null,
              // No email for printed photos
              additional_data: {
                auto_saved: true,
                action: 'photo_printed'
              }
            };
            _context0.n = 4;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(requestBody)
            });
          case 4:
            response = _context0.v;
            if (!response.ok) {
              _context0.n = 6;
              break;
            }
            _context0.n = 5;
            return response.json();
          case 5:
            record = _context0.v;
            console.log('✅ Print action auto-saved to database:', record.image_uri);
            _context0.n = 7;
            break;
          case 6:
            console.error('❌ Failed to auto-save print action to database');
          case 7:
            _context0.n = 9;
            break;
          case 8:
            _context0.p = 8;
            _t6 = _context0.v;
            console.error('❌ Error auto-saving print action:', _t6);
          case 9:
            setPrinted(true);
            console.log('✅ Plain image sent for printing successfully');
            _context0.n = 11;
            break;
          case 10:
            _context0.p = 10;
            _t7 = _context0.v;
            console.error('❌ Error in print:', _t7);
          case 11:
            _context0.p = 11;
            setIsPrinting(false);
            return _context0.f(11);
          case 12:
            return _context0.a(2);
        }
      }, _callee9, null, [[3, 8], [1, 10, 11, 12]]);
    }));
    return _handlePrintCall.apply(this, arguments);
  }
  var savePhotoToDatabase = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(imageDataUrl) {
      var requestBody, response, record, _t8;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            _context1.p = 0;
            console.log('💾 Auto-saving photo to database...');
            requestBody = {
              cell_id: cell.id,
              image: imageDataUrl,
              email: null,
              // No email for auto-saved photos
              additional_data: {
                auto_saved: true,
                action: 'photo_captured_only'
              }
            };
            _context1.n = 1;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(requestBody)
            });
          case 1:
            response = _context1.v;
            if (!response.ok) {
              _context1.n = 3;
              break;
            }
            _context1.n = 2;
            return response.json();
          case 2:
            record = _context1.v;
            console.log('✅ Photo auto-saved to database:', record.image_uri);
            _context1.n = 4;
            break;
          case 3:
            console.error('❌ Failed to auto-save photo to database');
          case 4:
            _context1.n = 6;
            break;
          case 5:
            _context1.p = 5;
            _t8 = _context1.v;
            console.error('❌ Error auto-saving photo:', _t8);
          case 6:
            return _context1.a(2);
        }
      }, _callee0, null, [[0, 5]]);
    }));
    return function savePhotoToDatabase(_x) {
      return _ref8.apply(this, arguments);
    };
  }();
  function captureOnePhoto() {
    return _captureOnePhoto.apply(this, arguments);
  } // Show instruction screens first (before any loading or error checks)
  function _captureOnePhoto() {
    _captureOnePhoto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
      var currentCount, countdownInterval;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            if (!started) {
              _context11.n = 1;
              break;
            }
            return _context11.a(2);
          case 1:
            setStarted(true);
            setStep(1);
            setPhotos([]); // reset existing photos
            setEmailSended(false); // reset email sent state

            // Simple countdown for single photo
            currentCount = 3;
            setCount(currentCount);
            countdownInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
              var video, canvas, ctx, imageData, data, photoDataUrl, _t9;
              return _regenerator().w(function (_context10) {
                while (1) switch (_context10.p = _context10.n) {
                  case 0:
                    setCount(currentCount - 1);
                    --currentCount;
                    if (!(currentCount <= 0)) {
                      _context10.n = 7;
                      break;
                    }
                    clearInterval(countdownInterval);

                    // Capture the single photo
                    video = videoRef.current;
                    if (video) {
                      _context10.n = 1;
                      break;
                    }
                    return _context10.a(2);
                  case 1:
                    if (!(video.videoWidth === 0 || video.videoHeight === 0)) {
                      _context10.n = 2;
                      break;
                    }
                    setStarted(false);
                    setStep(0);
                    return _context10.a(2);
                  case 2:
                    canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    ctx = canvas.getContext('2d');
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    data = imageData.data; // for (let i = 0; i < data.length; i += 4) {
                    //     const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
                    //     data[i] = data[i + 1] = data[i + 2] = avg;
                    // }
                    ctx.putImageData(imageData, 0, 0);
                    photoDataUrl = canvas.toDataURL('image/jpeg', 0.8);
                    setPhotos([photoDataUrl]);
                    setIsProcessingPhoto(true); // Show loading state

                    // Automatically save the photo to database (even if not shared)
                    _context10.p = 3;
                    _context10.n = 4;
                    return savePhotoToDatabase(photoDataUrl);
                  case 4:
                    _context10.n = 6;
                    break;
                  case 5:
                    _context10.p = 5;
                    _t9 = _context10.v;
                    console.error('Error auto-saving photo:', _t9);
                  case 6:
                    setStep(3); // Go directly to results screen
                  case 7:
                    return _context10.a(2);
                }
              }, _callee1, null, [[3, 5]]);
            })), 1000);
          case 2:
            return _context11.a(2);
        }
      }, _callee10);
    }));
    return _captureOnePhoto.apply(this, arguments);
  }
  if (showInstructions) {
    var currentInstruction = instructionData[instructionStep];
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: 'calc(100dvw - 10px)',
        height: 'calc(100dvh - 10px)',
        backgroundImage: "url(".concat(uriTransformer('https://web-treeosk.online/apks/jw_photobooth_instructions_screen_girl_bg.svg'), ")"),
        backgroundSize: '100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        border: '5px solid',
        borderImageSource: 'linear-gradient(90deg, #C5B086 0%, #FCE3B7 100%)',
        borderImageSlice: 1
      }
    }, /*#__PURE__*/_react.default.createElement("style", null, "\n                         @font-face {\n                             font-family: 'JohnnieWalkerHeadline';\n                             src: url('/jw_fonts/JohnnieWalker-Headline.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSans';\n                             src: url('/jw_fonts/JohnnieWalkerSans-Book.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSans';\n                             src: url('/jw_fonts/JohnnieWalkerSans-Bold.otf') format('opentype');\n                             font-weight: bold;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerScript';\n                             src: url('/jw_fonts/JohnnieWalkerScript-Regular.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSerif';\n                             src: url('/jw_fonts/JohnnieWalkerSerif-Book.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSerif';\n                             src: url('/jw_fonts/JohnnieWalkerSerif-Italic.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: italic;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Book.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Bold.otf') format('opentype');\n                             font-weight: bold;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Heavy.otf') format('opentype');\n                             font-weight: 900;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Medium.otf') format('opentype');\n                             font-weight: 500;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWJohnnie';\n                             src: url('/jw_fonts/JWJohnnie-Regular.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerBlueLabel';\n                             src: url('/jw_fonts/JohnnieWalkerBlueLabel.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCaps';\n                             src: url('/jw_fonts/JWCaps.ttf') format('truetype');\n                             font-weight: normal;\n                             font-style: normal;\n                         @font-face {\n                         font-family: 'JWBook';\n                         scr: url('/jw_fonts/JohnnieWalkerSans-Book.ttf') format('truetype')\n                         }\n\n\n                        }\n\n\n\n                        #root div:nth-child(2) > div:nth-child(1) > div:nth-child(1) {\n\n                            height: 100dvh !important;}\n\n                              #root  .react-grid-item.static.cssTransforms {\n                              height: 100dvh !important;\n                              width: 100dvw !important;}\n                     "), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: FONTS.sans,
        color: cell.text_color,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        top: '2em',
        right: '2em',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        // border: '3px solid white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
        // position: 'relative',
        // backgroundColor: 'rgba(0,0,0,0.3)'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        background: "conic-gradient(white ".concat(currentInstruction.progress * 3.6, "deg, transparent 0deg)"),
        zIndex: 1,
        display: 'none'
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      ref: circleRef,
      style: {
        position: "absolute",
        width: "100px",
        height: "100px",
        borderRadius: "50%",
        background: "conic-gradient(rgba(0,0,0,0.7) 0deg, rgba(252, 227, 183, 1) 0deg)",
        zIndex: 2
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: 'center',
        maxWidth: '90%'
      }
    }, /*#__PURE__*/_react.default.createElement("h1", {
      style: {
        fontFamily: FONTS.book,
        color: '#F9E0B5',
        fontSize: '2.8rem',
        fontWeight: 'bold',
        marginTop: '10rem',
        textTransform: 'uppercase',
        // textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
        // backgroundColor: 'rgba(0,0,0,0.3)',
        padding: '0'
        // borderRadius: '4px'
      }
    }, currentInstruction.title), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        fontFamily: FONTS.book,
        color: '#F9E0B5',
        fontSize: '1.3rem',
        margin: '0',
        marginTop: '5px',
        textTransform: 'uppercase',
        // letterSpacing: '0.1em',
        // textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
        // backgroundColor: 'rgba(0,0,0,0.3)',
        padding: '0',
        // borderRadius: '4px',
        lineHeight: '140%'
      }
    }, currentInstruction.instruction))));
  }

  // Show loading screen during photo processing
  if (isProcessingPhoto) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: FONTS.book,
        color: cell.text_color,
        width: '100%',
        height: '100%',
        backgroundImage: "url(".concat(uriTransformer('https://web-treeosk.online/apks/jw_normal_bg.svg'), ")"),
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '80px',
        height: '80px',
        border: '4px solid rgba(249, 224, 181, 0.3)',
        borderTop: '4px solid #F9E0B5',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '2em'
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: FONTS.caps,
        color: '#F9E0B5',
        fontSize: '1.5em',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
      }
    }, "PROCESSING PHOTO...")), /*#__PURE__*/_react.default.createElement("style", null, "\n                        @keyframes spin {\n                            0% { transform: rotate(0deg); }\n                            100% { transform: rotate(360deg); }\n                        }\n                             .react-grid-item.static.cssTransforms {\n                               height: calc(100dvh - 10px) !important;\n                          width: calc(100dvw - 10px) !important;\n                               border: 5px solid;\n                              border-image: linear-gradient(90deg, #C5B086 0%, #FCE3B7 100%) 1;\n                              }\n\n\n                         @font-face {\n                             font-family: 'JohnnieWalkerHeadline';\n                             src: url('/jw_fonts/JohnnieWalker-Headline.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSans';\n                             src: url('/jw_fonts/JohnnieWalkerSans-Book.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSans';\n                             src: url('/jw_fonts/JohnnieWalkerSans-Bold.otf') format('opentype');\n                             font-weight: bold;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerScript';\n                             src: url('/jw_fonts/JohnnieWalkerScript-Regular.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSerif';\n                             src: url('/jw_fonts/JohnnieWalkerSerif-Book.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSerif';\n                             src: url('/jw_fonts/JohnnieWalkerSerif-Italic.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: italic;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Book.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Bold.otf') format('opentype');\n                             font-weight: bold;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Heavy.otf') format('opentype');\n                             font-weight: 900;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Medium.otf') format('opentype');\n                             font-weight: 500;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWJohnnie';\n                             src: url('/jw_fonts/JWJohnnie-Regular.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerBlueLabel';\n                             src: url('/jw_fonts/JohnnieWalkerBlueLabel.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCaps';\n                             src: url('/jw_fonts/JWCaps.ttf') format('truetype');\n                             font-weight: normal;\n                             font-style: normal;\n                         @font-face {\n                         font-family: 'JWBook';\n                         scr: url('/jw_fonts/JohnnieWalkerSans-Book.ttf') format('truetype')\n                         }\n\n\n                        }\n                     "));
  }
  if (!isInitialized && loading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: FONTS.book,
        color: cell.text_color,
        width: '100%',
        height: '100%',
        backgroundImage: "url(".concat(uriTransformer('https://web-treeosk.online/apks/jw_normal_bg.svg'), ")"),
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '80px',
        height: '80px',
        border: '4px solid rgba(249, 224, 181, 0.3)',
        borderTop: '4px solid #F9E0B5',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }
    })), /*#__PURE__*/_react.default.createElement("style", null, "\n                        @keyframes spin {\n                            0% { transform: rotate(0deg); }\n                            100% { transform: rotate(360deg); }\n                        }\n\n                             .react-grid-item.static.cssTransforms {\n                               height: calc(100dvh - 10px) !important;\n                               width: calc(100dvw - 10px) !important;\n                               border: 5px solid;\n                               border-image: linear-gradient(90deg, #C5B086 0%, #FCE3B7 100%) 1;\n                              }\n                    "));
  }
  if (error && showRestartButton) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: FONTS.book,
        color: '#F9E0B5',
        width: '100%',
        height: '100vh',
        backgroundColor: '#000',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '80%',
        margin: 'auto',
        height: '80%',
        fontSize: '2em',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2em'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: '#FF6B6B',
        marginBottom: '1em'
      }
    }, "Erreur d'acc\xE8s \xE0 la cam\xE9ra : ", error.message), /*#__PURE__*/_react.default.createElement("button", {
      onClick: restartCamera,
      disabled: isRestarting,
      style: {
        fontFamily: FONTS.sans,
        background: isRestarting ? '#666' : '#C6B189',
        color: '#F9E0B5',
        padding: '20px 40px',
        borderRadius: '26px',
        fontSize: '24px',
        fontWeight: 'bold',
        cursor: isRestarting ? 'not-allowed' : 'pointer',
        border: 'none',
        minWidth: '200px',
        opacity: isRestarting ? 0.6 : 1,
        transition: 'all 0.3s ease'
      }
    }, isRestarting ? 'RESTARTING...' : 'RESTART CAMERA')));
  }
  switch (step) {
    case 0:
    case 1:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: FONTS.book,
          color: cell.text_color,
          width: '100vw',
          height: '100vh',
          position: 'fixed',
          top: 0,
          left: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#000',
          zIndex: 9999,
          overflow: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement("video", {
        ref: videoRef,
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
          transform: 'scaleX(-1)'
        },
        autoPlay: true,
        muted: true,
        playsInline: true,
        onError: function onError(e) {
          console.error('Video error:', e);
          setError(new Error('Camera stream lost'));
          setShowRestartButton(true);
        }
      }), /*#__PURE__*/_react.default.createElement("style", null, "\n                          .react-grid-item {\n\n                    height: 100dvh !important;\n                    width: 100dvw !important;\n                  }"), !isInitialized && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          fontSize: '2em',
          zIndex: 2,
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          background: 'rgba(0, 0, 0, 0.7)',
          padding: '1em',
          borderRadius: '10px'
        }
      }, "Loading...")), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
          pointerEvents: 'none'
        }
      }, step === 1 && count > 0 && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: uriTransformer("https://web-treeosk.online/apks/jw_photobooth_camera_counter_".concat(count, ".png")),
        alt: "Countdown ".concat(count),
        style: {
          width: 'min(20vw, 20vh, 300px)',
          height: 'min(20vw, 20vh, 300px)',
          objectFit: 'contain',
          filter: 'drop-shadow(0 4px 20px rgba(0, 0, 0, 0.8))'
        }
      }))));
    case 2:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: FONTS.book,
          color: cell.text_color,
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: "url(".concat(uriTransformer('https://web-treeosk.online/apks/jw_normal_bg.svg'), ")"),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '80%',
          height: '70%',
          border: 'solid 0.5em ' + cell.border_color,
          borderRadius: '20px',
          overflow: 'hidden',
          marginBottom: '2em'
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: photos[0],
        alt: "Captured Photo",
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transform: 'scaleX(-1)'
        }
      })));
    case 3:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: FONTS.book,
          color: cell.text_color,
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundImage: "url(".concat(uriTransformer('https://web-treeosk.online/apks/jw_normal_bg.svg'), ")"),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("style", null, "\n                          .react-grid-item {\n                          height: calc(100dvh - 10px) !important;\n                          width: calc(100dvw - 10px) !important;\n                          border: 5px solid;\n                          border-image: linear-gradient(90deg, #C5B086 0%, #FCE3B7 100%) 1;\n                  }\n\n\n                         @font-face {\n                             font-family: 'JohnnieWalkerHeadline';\n                             src: url('/jw_fonts/JohnnieWalker-Headline.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSans';\n                             src: url('/jw_fonts/JohnnieWalkerSans-Book.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSans';\n                             src: url('/jw_fonts/JohnnieWalkerSans-Bold.otf') format('opentype');\n                             font-weight: bold;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerScript';\n                             src: url('/jw_fonts/JohnnieWalkerScript-Regular.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSerif';\n                             src: url('/jw_fonts/JohnnieWalkerSerif-Book.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerSerif';\n                             src: url('/jw_fonts/JohnnieWalkerSerif-Italic.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: italic;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Book.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Bold.otf') format('opentype');\n                             font-weight: bold;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Heavy.otf') format('opentype');\n                             font-weight: 900;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCapsSans';\n                             src: url('/jw_fonts/JWCAPSSANS-Medium.otf') format('opentype');\n                             font-weight: 500;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWJohnnie';\n                             src: url('/jw_fonts/JWJohnnie-Regular.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JohnnieWalkerBlueLabel';\n                             src: url('/jw_fonts/JohnnieWalkerBlueLabel.otf') format('opentype');\n                             font-weight: normal;\n                             font-style: normal;\n                         }\n                         @font-face {\n                             font-family: 'JWCaps';\n                             src: url('/jw_fonts/JWCaps.ttf') format('truetype');\n                             font-weight: normal;\n                             font-style: normal;\n                         @font-face {\n                         font-family: 'JWBook';\n                         scr: url('/jw_fonts/JohnnieWalkerSans-Book.ttf') format('truetype')\n                         }\n\n                  "), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '80%',
          height: '76%',
          border: 'solid 0',
          // borderRadius: '20px',
          overflow: 'hidden',
          marginBottom: '2em',
          backgroundColor: '#273F81',
          boxShadow: '20px 20px 30px 0px #00000040'
        }
      }, currentDataUri ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, resultsStep === 3 && plainImageForPrint ? /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          backgroundImage: "url(".concat(plainImageForPrint, ")"),
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          borderRadius: '0px'
        }
      }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '77%',
          marginTop: '1.5em',
          backgroundImage: "url(".concat(currentDataUri, ")"),
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          borderRadius: '0px'
        }
      }), resultsStep !== 3 && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '20%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0.5em',
          backgroundColor: 'rgb(39, 63, 129)'
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: uriTransformer("https://web-treeosk.online/apks/johnnie_walker_vault_harrods_logo.png"),
        alt: "Johnnie Walker Vault x Harrods",
        style: {
          maxWidth: '90%',
          maxHeight: '100%',
          objectFit: 'contain'
        }
      })))) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
          padding: '20px'
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: instructionData[instructionStep].timerImage,
        alt: "Timer ".concat(instructionStep + 1),
        style: {
          width: '80px',
          height: '80px',
          objectFit: 'contain'
        }
      }))), currentDataUri && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '90%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1em'
        }
      }, resultsStep === 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          gap: '1em',
          minHeight: '120px'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          console.log('📧 Email option clicked - showing email form');
          setResultsStep(1);
        },
        style: {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5em',
          cursor: 'pointer'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '60px',
          // height: '60px',
          borderRadius: '50%',
          background: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: uriTransformer("https://web-treeosk.online/apks/jw-email.svg"),
        alt: "Email",
        style: {
          width: '80px',
          height: '80px'
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: FONTS.sans,
          color: '#F9E0B5',
          fontSize: '1em',
          // fontWeight: 'bold',
          textAlign: 'center',
          // textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
          backgroundColor: 'transparent',
          padding: '0.5em',
          borderRadius: '4px',
          marginTop: '0.3em'
        }
      }, "SEND BY EMAIL")), /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          return setResultsStep(2);
        },
        style: {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5em',
          cursor: 'pointer'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '60px',
          // height: '60px',
          borderRadius: '50%',
          background: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: uriTransformer("https://web-treeosk.online/apks/jw-download.svg"),
        alt: "Download",
        style: {
          width: '80px',
          height: '80px'
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: FONTS.sans,
          color: '#F9E0B5',
          fontSize: '1em',
          // fontWeight: 'bold',
          textAlign: 'center',
          // textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
          backgroundColor: 'transparent',
          padding: '0.5em',
          borderRadius: '4px',
          marginTop: '0.3em'
        }
      }, "DOWNLOAD")), /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          return setResultsStep(3);
        },
        style: {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5em',
          cursor: 'pointer'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '60px',
          // height: '60px',
          borderRadius: '50%',
          background: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: uriTransformer("https://web-treeosk.online/apks/jw-print.svg"),
        alt: "Print",
        style: {
          width: '80px',
          height: '80px'
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: FONTS.sans,
          color: '#F9E0B5',
          fontSize: '1em',
          // fontWeight: 'bold',
          textAlign: 'center',
          // textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
          backgroundColor: 'transparent',
          padding: '0.5em',
          borderRadius: '4px',
          marginTop: '0.3em'
        }
      }, "PRINT THE PHOTO"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginTop: '1em',
          fontFamily: FONTS.book
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick() {
          setStarted(false);
          setStep(0);
          setPhotos([]);
          setCurrentDataUri(null);
          setForPrint(null);
          setLink('');
          setPrinted(false);
          setEmailSended(false);
          setResultsStep(0);
          setIsProcessingPhoto(false);
          // Reset instruction screens to start over
          setShowInstructions(true);
          setInstructionStep(0);
          setIsInitialized(false);
          setLoading(true);
          setError(null);
          // Restart animation
          setAnimationKey(function (prev) {
            return prev + 1;
          });
        },
        style: {
          fontFamily: FONTS.sans,
          background: '#C6B1894D',
          color: '#F9E0B5',
          border: 'none',
          padding: '1em 2em',
          borderRadius: '26px',
          fontSize: '16PX',
          fontWeight: '400',
          cursor: 'pointer',
          letterSpacing: '0.1em'
        }
      }, "START AGAIN"))), resultsStep === 1 && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '60%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: FONTS.sans,
          width: '80%',
          padding: '0.5em',
          borderRadius: '32px',
          border: '1px solid #ccc',
          fontSize: '14px',
          background: '#C6B18966',
          textAlign: 'center',
          color: '#F9E0B599',
          lineHeight: '260%'
        },
        onClick: function onClick() {
          setKeyboardVisible(true);
        }
      }, emailAddress || 'Email'), /*#__PURE__*/_react.default.createElement("style", null, "\n                                            @keyframes emailSpinner {\n                                                0% { transform: rotate(0deg); }\n                                                100% { transform: rotate(360deg); }\n                                            }\n                                        "), isSending ? /*#__PURE__*/
      // Show loading spinner while sending
      _react.default.createElement("div", {
        style: {
          width: '80%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '120px'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '40px',
          height: '40px',
          border: '4px solid #FCE3B7',
          borderTop: '4px solid transparent',
          borderRadius: '50%',
          animation: 'emailSpinner 1s linear infinite'
        }
      })) : /*#__PURE__*/
      // Show checkboxes when not sending
      _react.default.createElement("div", {
        style: {
          width: '80%',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5em'
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        style: {
          fontFamily: FONTS.sans,
          color: "#F9E0B5",
          fontSize: "10px",
          display: "flex",
          alignItems: "flex-start",
          // checkbox aur text top align
          gap: "0.5em",
          backgroundColor: "transparent",
          padding: "0.5em",
          borderRadius: "4px",
          lineHeight: "130%",
          cursor: "pointer"
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          width: "16px",
          height: "16px",
          border: "2px solid #F9E0B5",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          // checkbox size fix
          marginTop: "0.2em",
          // vertical adjust
          position: "relative"
        }
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "checkbox",
        checked: termsAccepted,
        onChange: function onChange(e) {
          return setTermsAccepted(e.target.checked);
        },
        style: {
          position: "absolute",
          opacity: 0,
          width: "100%",
          height: "100%",
          margin: 0,
          cursor: "pointer"
        }
      }), termsAccepted && /*#__PURE__*/_react.default.createElement("span", {
        style: {
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: "#F9E0B5"
        }
      })), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          display: "block"
        }
      }, "I can confirm I\u2019m over 18 and I have read and accept the T&C's and consent to the collection and processing of my personal data in accordance with Diageo's Privacy Policy")), /*#__PURE__*/_react.default.createElement("label", {
        style: {
          fontFamily: FONTS.sans,
          color: "#F9E0B5",
          fontSize: "10px",
          display: "flex",
          alignItems: "flex-start",
          // checkbox aur text top align
          gap: "0.5em",
          backgroundColor: "transparent",
          padding: "0.5em",
          borderRadius: "4px",
          lineHeight: "130%",
          cursor: "pointer"
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          width: "16px",
          height: "16px",
          border: "2px solid #F9E0B5",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          // checkbox size fix
          marginTop: "0.2em",
          // vertical adjust
          position: "relative"
        }
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "checkbox",
        checked: marketingAccepted,
        onChange: function onChange(e) {
          return setMarketingAccepted(e.target.checked);
        },
        style: {
          position: "absolute",
          opacity: 0,
          width: "100%",
          height: "100%",
          margin: 0,
          cursor: "pointer"
        }
      }), marketingAccepted && /*#__PURE__*/_react.default.createElement("span", {
        style: {
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: "#F9E0B5"
        }
      })), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          display: "block"
        }
      }, "I would like to receive marketing communications about Harrods products, services and promotions and consent to Diageo sharing my personal data with Harrods for this purpose. For information on how Harrods handle personal data, please visit the Harrods\xA0Privacy\xA0Policy."))), /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick() {
          console.log('🔘 Email send button clicked!');
          console.log('📧 Email address:', emailAddress);
          console.log('✅ Terms accepted:', termsAccepted);
          console.log('📝 Marketing accepted:', marketingAccepted);
          console.log('🖼️ ForPrint available:', !!forPrint);

          // Ensure forPrint is ready before sending
          if (!forPrint) {
            console.log('⚠️ ForPrint not ready, waiting...');
            // Wait a bit and try again
            setTimeout(function () {
              if (forPrint) {
                console.log('🚀 Sending email...');
                handleEmailSend();
                // Don't automatically navigate away - let user see "EMAIL SENT" state
              } else {
                console.error('❌ ForPrint still not ready after timeout');
              }
            }, 1000);
            return;
          }

          // Handle email sending
          console.log('🚀 Sending email...');
          handleEmailSend();
          // Don't automatically navigate away - let user see "EMAIL SENT" state
        },
        disabled: !termsAccepted || !forPrint || emailSended || isSending,
        style: {
          fontFamily: FONTS.sans,
          background: emailSended ? '#FCE3B7' : termsAccepted && forPrint ? '#FCE3B7' : '#ccc',
          color: emailSended ? '#04047E' : termsAccepted && forPrint ? '#04047E' : '#666',
          border: 'none',
          padding: '15px 40px',
          borderRadius: '26px',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: emailSended ? 'not-allowed' : termsAccepted && forPrint ? 'pointer' : 'not-allowed',
          width: 'fit-content',
          opacity: emailSended ? 1 : termsAccepted && forPrint ? 1 : 0.6
        }
      }, emailSended ? 'EMAIL SENT' : isSending ? 'SENDING...' : 'SEND THE PHOTO'), /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick() {
          setResultsStep(0);
          setEmailSended(false); // Reset email sent state when going back
        },
        style: {
          fontFamily: FONTS.sans,
          background: '#C6B1894D',
          color: '#F9E0B5',
          padding: '15px 25px',
          borderRadius: '26px',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: 'pointer',
          marginTop: '0.5em',
          border: '0'
          // textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
        }
      }, "BACK")), resultsStep === 2 && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1em',
          fontFamily: FONTS.book
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          // flexDirection: 'column',
          alignItems: 'center',
          gap: '1em',
          width: '80%',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          background: 'tranparent',
          padding: '1em',
          borderRadius: '8px'
        }
      }, link ? /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
        value: link,
        size: 150
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '150px',
          height: '150px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'white',
          borderRadius: '8px',
          color: '#666',
          fontSize: '12px',
          textAlign: 'center'
        }
      }, "Generating QR Code...")), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: FONTS.sans,
          color: '#F9E0B5',
          fontSize: '32px',
          // fontWeight: 'bold',
          textAlign: 'left',
          backgroundColor: 'transparent',
          padding: '0.5em',
          borderRadius: '4px',
          lineHeight: '130%'
          // textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
        }
      }, "SCAN THE QR CODE", /*#__PURE__*/_react.default.createElement("br", null), "TO SAVE YOUR PHOTO")), /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick() {
          return setResultsStep(0);
        },
        style: {
          fontFamily: FONTS.sans,
          background: '#C6B1894D',
          color: '#F9E0B5',
          padding: '15px 25px',
          borderRadius: '26px',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: 'pointer',
          marginTop: '0.5em',
          border: '0'
        }
      }, "BACK")), resultsStep === 3 && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1em'
        }
      }, isPrinting ? /*#__PURE__*/
      // Show loading spinner while printing
      _react.default.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1em',
          width: '60%',
          minHeight: '120px'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '40px',
          height: '40px',
          border: '4px solid #FCE3B7',
          borderTop: '4px solid transparent',
          borderRadius: '50%',
          animation: 'emailSpinner 1s linear infinite'
        }
      })) : /*#__PURE__*/
      // Show print button when not printing
      _react.default.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
          width: '60%',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: handlePrintCall,
        disabled: printed,
        style: {
          fontFamily: FONTS.book,
          background: '#FCE3B7',
          color: '#04047E',
          border: 'none',
          padding: '0.5em 0.1em',
          borderRadius: '38.5px',
          fontSize: '0.8em',
          fontWeight: 'bold',
          cursor: printed ? 'not-allowed' : 'pointer',
          opacity: printed ? 0.6 : 1,
          width: '75%'
        }
      }, printed ? 'PRINTED' : 'PRINT THE PHOTO')), /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick() {
          setResultsStep(0);
          setIsPrinting(false); // Reset printing state when going back
        },
        style: {
          fontFamily: FONTS.sans,
          background: '#C6B1894D',
          color: '#F9E0B5',
          padding: '15px 25px',
          borderRadius: '26px',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: 'pointer',
          marginTop: '0.5em',
          border: '0'
        }
      }, "BACK"))), keyboardVisible && cell.email && /*#__PURE__*/_react.default.createElement(_AzertyKeyboard.default, {
        field_name: 'Email',
        setVisible: setKeyboardVisible,
        project: project,
        input: emailAddress,
        setInput: setEmailAddress
      }));
    default:
      return null;
  }
}
function LoadingSvg(_ref66) {
  var cell = _ref66.cell,
    animated = _ref66.animated;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "30",
    height: "30",
    viewBox: "0 0 50 50",
    style: {
      animation: animated ? 'spin 1s linear infinite' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("style", null, "\n                    @keyframes spin {\n                        0% { transform: rotate(0deg); }\n                        100% { transform: rotate(360deg); }\n                    }\n                "), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    stroke: cell.text_color,
    strokeWidth: "5",
    strokeDasharray: "31.416",
    strokeDashoffset: "31.416"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "stroke-dasharray",
    dur: "2s",
    values: "0 31.416;15.708 15.708;0 31.416",
    repeatCount: "indefinite"
  })));
}